import { render, staticRenderFns } from "./voteuser.vue?vue&type=template&id=40942d1d&scoped=true&"
import script from "./voteuser.vue?vue&type=script&lang=js&"
export * from "./voteuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40942d1d",
  null
  
)

export default component.exports